import { render, staticRenderFns } from "./kaitongvip.vue?vue&type=template&id=3c684f74&scoped=true&"
import script from "./kaitongvip.vue?vue&type=script&lang=js&"
export * from "./kaitongvip.vue?vue&type=script&lang=js&"
import style0 from "./kaitongvip.vue?vue&type=style&index=0&id=3c684f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c684f74",
  null
  
)

export default component.exports